import React, { useState } from "react";
import LandingAppsButtons from "./landingAppsButtons";
import { FiMail, FiUser, FiSend, FiSmartphone, FiCheckCircle } from "react-icons/fi";
import toast from "react-hot-toast";

export const LandingOthers: React.FC = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setSubscribed(true);
    toast.success("Thank you for subscribing to Pendulum Digital!");
  };

  return (
    <div id="newsletter" className="py-20 bg-slate-50 relative overflow-hidden">
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-20">
        
        {/* Newsletter Subscription Card */}
        <div data-aos="fade-up" className="bg-gradient-to-r from-blue-900 via-indigo-900 to-slate-900 rounded-[2.5rem] p-8 sm:p-14 shadow-2xl text-white relative overflow-hidden">
          
          <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center relative z-10">
            
            {/* Newsletter Text Info */}
            <div className="lg:col-span-6 space-y-4">
              <span className="inline-block px-4 py-1.5 rounded-full bg-blue-500/20 text-blue-300 text-xs font-black uppercase tracking-widest border border-blue-400/20">
                Newsletter & Insights
              </span>
              <h2 className="text-3xl sm:text-4xl font-black leading-tight">
                Stay Ahead of Educational Trends
              </h2>
              <p className="text-xs sm:text-sm text-slate-300 font-medium leading-relaxed">
                Subscribe to our newsletter and be the first to know about new features, tips on maximizing school efficiency, and insights into the future of digital education in Africa.
              </p>

              <div className="flex items-center gap-4 pt-2 text-xs font-bold text-blue-200">
                <span className="flex items-center gap-1.5">
                  <FiCheckCircle className="text-emerald-400" /> Monthly Feature Updates
                </span>
                <span className="flex items-center gap-1.5">
                  <FiCheckCircle className="text-emerald-400" /> No Spam Guarantee
                </span>
              </div>
            </div>

            {/* Newsletter Form */}
            <div className="lg:col-span-6">
              {subscribed ? (
                <div className="bg-emerald-500/20 border border-emerald-500/30 rounded-3xl p-8 text-center space-y-3 backdrop-blur-md">
                  <div className="w-12 h-12 bg-emerald-500 text-white rounded-2xl flex items-center justify-center mx-auto text-xl font-bold">
                    ✓
                  </div>
                  <h4 className="text-xl font-black text-white">You're Subscribed!</h4>
                  <p className="text-xs text-emerald-200 font-medium">
                    We've sent a confirmation email to <strong>{email}</strong>. Stay tuned for our upcoming updates!
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubscribe} className="bg-white/10 p-6 sm:p-8 rounded-[2rem] border border-white/15 backdrop-blur-md space-y-4">
                  
                  <div className="relative">
                    <FiUser className="absolute left-4 top-4 text-slate-400" size={18} />
                    <input
                      type="text"
                      placeholder="Enter Full Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="w-full bg-white/10 border border-white/20 rounded-2xl pl-11 pr-4 py-3.5 text-xs font-bold text-white placeholder:text-slate-400 outline-none focus:border-blue-400 focus:bg-white/20 transition-all"
                    />
                  </div>

                  <div className="relative">
                    <FiMail className="absolute left-4 top-4 text-slate-400" size={18} />
                    <input
                      type="email"
                      placeholder="Enter Email Address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full bg-white/10 border border-white/20 rounded-2xl pl-11 pr-4 py-3.5 text-xs font-bold text-white placeholder:text-slate-400 outline-none focus:border-blue-400 focus:bg-white/20 transition-all"
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full py-4 rounded-2xl font-black text-xs uppercase tracking-widest text-white bg-blue-600 hover:bg-blue-500 shadow-xl transition-all flex items-center justify-center gap-2"
                  >
                    <FiSend size={16} /> Subscribe To Newsletter
                  </button>
                </form>
              )}
            </div>

          </div>
        </div>

        {/* Download App Banner */}
        <div data-aos="fade-up" className="bg-white rounded-[2.5rem] p-8 sm:p-12 border border-slate-200/80 shadow-xl grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          
          <div className="lg:col-span-5 flex justify-center">
            <div className="relative w-64 h-64 sm:w-80 sm:h-80 bg-blue-50 rounded-[2.5rem] p-6 border border-blue-100 flex items-center justify-center">
              <img
                src="/10.svg"
                alt="Mobile App"
                className="max-h-full w-auto object-contain transition-transform hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = "none";
                }}
              />
              <div className="absolute -bottom-3 -right-3 bg-slate-900 text-white text-[11px] font-black px-4 py-2 rounded-2xl shadow-lg flex items-center gap-2">
                <FiSmartphone className="text-blue-400" /> iOS & Android Ready
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-6 text-center lg:text-left">
            <span className="text-xs font-black uppercase tracking-widest text-blue-600 bg-blue-50 px-4 py-1.5 rounded-full border border-blue-100">
              On-The-Go Access
            </span>

            <h3 className="text-2xl sm:text-4xl font-black text-slate-900 tracking-tight">
              Download the Pendulum Mobile App
            </h3>

            <p className="text-xs sm:text-base text-slate-600 font-medium leading-relaxed">
              Take electronic communication, daily childcare tracking, and learning management to the next level with the Pendulum Digital app on your phone.
            </p>

            <div className="pt-2 flex justify-center lg:justify-start">
              <LandingAppsButtons />
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default LandingOthers;
